




































































import { Vue, Component } from "vue-property-decorator";
import { auth, settings } from "@/loader/public";

@Component
export default class Login extends Vue {
	public loading: boolean = false;
	public login: string = "";
	public password: string = "";
	public rememberMe: boolean = false;

	public get logo(): string {
		return settings.logo_url;
	}

	public get company_name(): string {
		return settings.company_name;
	}

	public doLogin() {
		this.loading = true;
		auth.login({
			username: this.login,
			password: this.password,
			// rememberMe: this.rememberMe,
		}).then(response => {
			if (auth.isLoggedIn) {
				if (this.$router.currentRoute.name !== "Home") {
					this.$router.push({ name: "Home" });
				}
			}
		}).finally(() => {
			this.loading = false;
		});
	}

	public lostPassword() {
		this.loading = true;
		auth.forgotPassword(this.login).then(response => {
			this.loading = false;
		});
	}

	public mounted() {
		if (auth.isLoggedIn) {
			this.$router.push({ name: "Home" });
		}
	}
}
